import axiosBackend from '../axiosBackend';

export async function sendEmail(emailData) {
  try {
    const { data } = await axiosBackend.post('/mailing/send-email', emailData);
    return data;
  } catch (error) {
    return error.response ? error.response : error;
  }
}

export default {
  sendEmail,
}; 